import urlUitls from '../../../static/js/urlUitls'

const apiUrls = {
  read: 'http://127.0.0.1:7000/api/rfid/read',
  write: 'http://127.0.0.1:7000/api/rfid/write',
  // 制卡重复利用逻辑校验接口地址
  validate: {
    url: 'rest/main/goods/lnk/customized_catalog/checkEPC',
    params: {
      criteriaCode: 'ILNK_STORAGEITEM_EPC_CHECK',
    },
  },
}

// 请求函数
function fetch(vue, url, data, method = 'get', success, fail) {
  let _url = url
  if (!url) return [false]
  if (method === 'post' && !data) return [false]
  if (method === 'get' && data) {
    _url += _url.indexOf('?') > -1 ? '&' : '?'
    _url += urlUitls.paramSerializer(data)
  }

  return new Promise((resolve) => {
    try {
      vue.$axios[method](_url, data)
        .then((res) => {
          success?.(res)
          resolve([true, res])
        })
        .catch(() => {
          fail?.()
          resolve([false])
        })
    } catch (error) {
      fail?.()
      resolve([false])
    }
  })
}

export default {
  // 校验是否写卡成功
  async checkWrite(vue, params) {
    console.log('开始校验...')
    const [success, res] = await this.readRfid(vue)
    if (!success) return [false]

    console.log('================= 校验是否写卡成功 =================')
    console.log('写入后读取的数据: ', res?.data?.data)
    console.log('待写入的数据: ', params?.data)
    console.log('================= END =================')
    // 比较读取的数据是否和写入的数据一致
    if (res?.data?.data !== params?.data) {
      return [false, { message: '写卡失败，可能原因：写入的数据与写入后校验的数据不一致！' }]
    }

    return [true, res]
  },

  // 读卡
  async readRfid(vue, params) {
    if (!vue) throw new Error('参数 vue 必传！')
    console.log('开始读卡...')

    const [success, res] = await fetch(vue, apiUrls.read, { ...params, part: 'epc' }, 'get')
    if (!success) return [false]

    return [true, res]
  },

  // 写卡
  async writeRfid(vue, params) {
    if (!vue) throw new Error('参数 vue 必传！')
    console.log('开始写卡...')

    // 制卡重复利用逻辑校验
    const [readSuccess, readRes] = await this.readRfid(vue)
    if (readSuccess) {
      const epc = readRes.data.data
      // 调用后台接口校验
      const [apiSuccess, apiRes] = await fetch(
        vue,
        apiUrls.validate.url,
        {
          ...apiUrls.validate.params,
          parameters: { epc },
        },
        'post'
      )

      if (apiSuccess && apiRes?.data?.data?.[0]?.stocking > 0) {
        vue.$pgMessage.confirm({
          title: '确认操作',
          content: `当前RFID芯片中的EPC号${epc}还处于【现存量】待使用状态，确认覆盖制卡？`,
          showCancelBtn: true,
          cancelBtnText: '取消',
          onOk: async () => {
            // 校验格式
            if (epc && !(epc.length % 4)) {
              console.log('================= 待写入的数据 =================')
              console.log('epc: ', epc)
              console.log('================= END =================')

              // 开始写卡...
              await this.writeDoing(vue, params)
            } else {
              this.$Message.error('待写入的 epc 数据格式不正确')
            }
          },
        })

        return
      }
    }

    // 开始写卡...
    await this.writeDoing(vue, params)
  },

  // 写卡执行
  async writeDoing(vue, params) {
    const [success] = await fetch(vue, apiUrls.write, { ...params, part: 'epc' }, 'get')
    if (!success) return [false]

    // 校验是否写卡成功
    setTimeout(async () => {
      const [valid, validRes] = await this.checkWrite(vue, params)
      if (!valid) {
        vue.$Message.error(validRes.message)
        return
      }
      vue.$Message.success('制卡成功')
    }, 200)
  },
}
